import { render, staticRenderFns } from "./SequenceSuggestions.vue?vue&type=template&id=5dbd5c92&"
import script from "./SequenceSuggestions.vue?vue&type=script&lang=js&"
export * from "./SequenceSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./SequenceSuggestions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports